import store from '../store'
import { getUser } from '../api'
// import axios from 'axios';
// import { toScrollAnimation } from '../library'

export default function (to, from, next) {
  if (to.path === '/sso/return') { next(); return }
  getUser().then(() => {
    next()
  }).catch(err => {
    console.log(err)
  })

  const monthlyRoutes = ['Monthly', 'MonthlyDetail']
  if (!(monthlyRoutes.includes(to.name) && monthlyRoutes.includes(from.name))) window.scrollTo({ top: 0 })
  if (to.meta) {
    if (store.state.Seometas) {
      document.querySelector('title').innerHTML = store.state.Seometas.title + (to.meta.title ? ' - ' + to.meta.title : '')
    } else {
      document.querySelector('title').innerHTML = '東震股份有限公司' + (to.meta.title ? ' - ' + to.meta.title : '')
    }
  }
  next()
}
